'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var PropTypes = _react2['default'].PropTypes;
exports['default'] = _react2['default'].createClass({
  displayName: 'item',

  mixins: [_reactDnd.DragDropMixin],

  propTypes: {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  },

  statics: {
    configureDragDrop: function configureDragDrop(registerType) {
      registerType('module_type_item', {
        dragSource: {
          beginDrag: function beginDrag(component) {
            return {
              item: {
                id: component.props.id
              }
            };
          }
        }
      });
    }
  },

  render: function render() {
    var component = this;

    var _component$getDragState = component.getDragState('module_type_item');

    var isDragging = _component$getDragState.isDragging;
    var _component$props = component.props;
    var id = _component$props.id;
    var title = _component$props.title;
    var description = _component$props.description;
    var onClick = _component$props.onClick;

    return _react2['default'].createElement(
      'div',
      _extends({
        key: id
      }, component.dragSourceFor('module_type_item'), {
        className: 'item-component module-item-component', onClick: onClick }),
      _react2['default'].createElement(
        'div',
        { className: 'title' },
        title
      ),
      _react2['default'].createElement(
        'div',
        { className: 'description' },
        description
      )
    );
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/item.js
 **/